module.exports = __webpack_public_path__ + "img/vice_banner_title.c0db5545.png";